import { InputControl } from "./input-control";

export class FileInput extends InputControl {

    getData() {
        return this.element.multiple ? this.element.files : this.element.files[0];
    }

    appendData(form: FormData) {
        if (this.element.files.length) {
            super.appendData(form);
        }
    }
}
